module.exports = __webpack_public_path__ + "img/project-ended.74b9b25f.png";